var _path, _path2, _g, _g2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 42,
    viewBox: "0 0 36 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77734 39.5238V29.0476L16.1107 35.7143L4.77734 39.5238Z",
    fill: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2227 39.5238V29.0476L19.8893 35.7143L31.2227 39.5238Z",
    fill: "#969696"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_862_10117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0009 0L34.0564 9.52381V28.5714L18.0009 38.0952L1.94531 28.5714V9.52381L18.0009 0Z",
    fill: "#969696"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_862_10117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0004 4.76196L30.2782 11.9048V26.1905L18.0004 33.3334L5.72266 26.1905V11.9048L18.0004 4.76196Z",
    fill: "url(#paint0_linear_862_10117)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4551 25.7144H18.7374C21.5144 25.7144 22.9934 24.2533 22.9934 22.2687C22.9934 20.4242 21.6834 19.3101 20.2768 19.2432V19.1214C21.5627 18.8292 22.5105 17.91 22.5105 16.4428C22.5105 14.5739 21.1341 13.2468 18.4054 13.2468H13.4551V25.7144ZM16.0691 23.5593V20.2476H18.2605C19.5162 20.2476 20.2949 20.9782 20.2949 22.007C20.2949 22.9445 19.661 23.5593 18.2001 23.5593H16.0691ZM16.0691 18.464V15.3775H18.0552C19.2143 15.3775 19.8723 15.9802 19.8723 16.8812C19.8723 17.8674 19.0755 18.464 18.0069 18.464H16.0691Z",
    fill: "#646464"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94531 28.5714V9.52381L18.0009 0V4.76191L5.72309 11.9048V26.1905L1.94531 28.5714Z",
    fill: "#CACACA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_862_10117",
    x: 0.945312,
    y: 0,
    width: 34.1113,
    height: 41.0952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_862_10117"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_862_10117",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_862_10117",
    x: 5.72266,
    y: 4.76196,
    width: 24.5547,
    height: 29.5715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.391951 0 0 0 0 0.391951 0 0 0 0 0.391951 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_862_10117"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_862_10117",
    x1: 3.38403,
    y1: 4.76196,
    x2: 34.4568,
    y2: 35.1806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/B.adabd891d45fd7bca1a4682268e94c5b.svg";
export { ForwardRef as ReactComponent };